import { render } from "./Search.vue?vue&type=template&id=5fc3cca0"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=5fc3cca0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__